import { useTranslation } from 'react-i18next';
import JxtCollapsibleFilter from '../JxtCollapsibleFilter';
import JxtTree from '../JxtTree';
import { IJxtTreeNode } from '../JxtTree/types';
import { IJxtCollapsibleTree } from './types';
import { convertValues } from '../JxtCollapsibleCheckboxList/helpers';

function getLeafEntries(nodes: IJxtTreeNode[]): { value: string; label: string }[] {
  return nodes.flatMap((n) => (n.children?.length ? getLeafEntries(n.children) : [{ value: n.value, label: n.label }]));
}

const JxtCollapsibleTree = ({
  label,
  allOrNoneSelectedOptionsLabel,
  defaultFolded = true,
  disabled = false,
  onFoldChange,
  nodes,
  checkedValue,
  onCheckedChange,
  expandedValue,
  onExpandedChange,
  className,
}: IJxtCollapsibleTree) => {
  const { t } = useTranslation();
  const allLeaves = getLeafEntries(nodes);
  const selectedLabels = allLeaves.filter((leaf) => checkedValue.includes(leaf.value)).map((leaf) => leaf.label);

  const values =
    checkedValue.length === 0 || selectedLabels.length === allLeaves.length
      ? (allOrNoneSelectedOptionsLabel ?? t<string>('collapsible.checkbox.list-all'))
      : selectedLabels;

  const value = convertValues(values);

  return (
    <JxtCollapsibleFilter label={label} value={value} defaultFolded={defaultFolded} disabled={disabled} onFoldChange={onFoldChange}>
      <JxtTree
        nodes={nodes}
        checkedValue={checkedValue}
        onCheckedChange={onCheckedChange}
        expandedValue={expandedValue}
        onExpandedChange={onExpandedChange}
        className={className}
      />
    </JxtCollapsibleFilter>
  );
};

export default JxtCollapsibleTree;
